import { styled } from "../../../styles";

export const ChartValueContainer = styled("div", {
  display: "flex",
  width: "100%",

  justifyContent: "space-between",

  marginTop: "24px",

  variants: {
    isEmpty: {
      true: {
        marginBottom: "22px",
      },
    },
  },
});

export const Label = styled("p", {
  fontSize: "$text-md",
  lineHeight: "16px",

  color: "$gray-100",
});

export const Value = styled("p", {
  fontWeight: 600,

  fontSize: "$text-lg",
  lineHeight: "22px",

  color: "$gray-100",
});

export const TooltipContainer = styled("p", {
  display: "flex",
  flexDirection: "column",

  padding: "6px 10px 10px 10px",
});

export const TooltipTitle = styled("p", {
  fontWeight: 600,

  fontSize: "14px",
  lineHeight: "22px",

  color: "$white",
});

export const TooltipLabel = styled("p", {
  fontWeight: 600,

  fontSize: "12px",
  lineHeight: "16px",

  color: "$gray-60",
});
